import { lazy } from 'react';
import type { ToolConfig } from '@/types/tool';

export const epochConverterConfig: ToolConfig = {
  id: 'epoch-converter',
  path: '/tools/epoch-converter',
  meta: {
    title: 'Epoch Converter',
    description:
      'Convert Unix timestamps to human-readable dates and vice versa. Supports multiple formats, timezones, batch conversion, and specialty converters.',
    keywords: [
      'epoch',
      'unix timestamp',
      'date converter',
      'time converter',
      'timestamp',
      'milliseconds',
      'timezone',
      'LDAP',
      'UTC',
    ],
    icon: 'Clock',
    category: 'time',
    isNew: true,
    gradient: 'from-amber-500 to-orange-600',
  },
  component: lazy(() => import('./EpochConverter')),
};
